import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'rebass';

const SmallButton = ({ children, ...props }) => (
  <Button
    style={{
      lineHeight: 1,
      minHeight: 20,
      fontSize: 10,
    }}
    p={1}
    {...props}
  >
    {children}
  </Button>
);

SmallButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SmallButton;
